export default "__VITE_ASSET__BdhrxMDn__"